const schools = {
    participating() {
        /**
         * Find the element for the components
         */
        document.querySelectorAll('[data-component="schools-participating"]').forEach((component) => {
            /**
             * Toggle the state for the participating schools list
             */
            component.querySelectorAll('.toggle-area').forEach((area) => {
                area.classList.add('hidden');

                if (area.getAttribute('id') === 'main') {
                    area.classList.remove('hidden');
                }
            });

            /**
             * Attach a custom click event to each image zone
             */
            component.querySelectorAll('.map-zone').forEach((zone) => {
                zone.addEventListener('click', (event) => {
                    /**
                     * Prevent the default browser behavior
                     * and set variables and atributes for the action
                     */
                    event.preventDefault();
                    let attributes = {};

                    /**
                     * Collect the attributes information
                     */
                    attributes.id = zone.getAttribute('data-zone-id');

                    /**
                     * By default we will hide all section
                     */
                    component.querySelectorAll('.toggle-area').forEach((area) => {
                        area.classList.add('hidden');
                    });

                    /**
                     * Display the section for the selected region
                     */
                    if (component.querySelector('.toggle-area[data-id="' + attributes.id + '"]')) {
                        component.querySelector('.toggle-area[data-id="' + attributes.id + '"]').classList.remove('hidden');
                    }

                    /**
                     * Remove the class from all elements in the navigation
                     */
                    component.querySelectorAll('.map-navigation li a.map-zone').forEach((navigation) => {
                        navigation.classList.remove('active');
                    });

                    /**
                     * Attach the class to the curent item
                     */
                    if (component.querySelector('.map-navigation li a[data-zone-id="' + attributes.id + '"]')) {
                        component.querySelector('.map-navigation li a[data-zone-id="' + attributes.id + '"]').classList.add('active');
                    }
                });
            });

            /**
             * Attach a custom click event to each navigation item
             */
            component.querySelectorAll('.map-navigation li a').forEach((navigation) => {
                navigation.addEventListener('click', (event) => {
                    /**
                     * Remove the class from all elements in the navigation
                     */
                    component.querySelectorAll('.map-navigation li a').forEach((navigation) => {
                        navigation.classList.remove('active');
                    });

                    /**
                     * Attach the class to the curent item
                     */
                    navigation.classList.add('active');
                });
            });

            /**
             * Attach a custom click event to map zone
             */
            component.querySelectorAll('.map-zone').forEach((item) => {
                item.addEventListener('click', (event) => {
                    /**
                     * Prevent the default browser behavior
                     * and set variables and atributes for the action
                     */
                    event.preventDefault();
                    let attributes = {};

                    /**
                     * Collect the attributes information
                     */
                    attributes.id = item.getAttribute('data-zone-id');
                    attributes.image = item.getAttribute('data-image');

                    /**
                     * Replace the map image with the selected region
                     */
                    if (component.querySelector('.img-for-change')) {
                        component.querySelector('.img-for-change').setAttribute('src', attributes.image);
                    }
                });
            });
        });
    }
}

export default schools;
